import { render, staticRenderFns } from "./CustomAssetsHistory.vue?vue&type=template&id=768d47d1&scoped=true&"
import script from "./CustomAssetsHistory.vue?vue&type=script&lang=js&"
export * from "./CustomAssetsHistory.vue?vue&type=script&lang=js&"
import style0 from "./CustomAssetsHistory.vue?vue&type=style&index=0&id=768d47d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768d47d1",
  null
  
)

export default component.exports